export default __webpack_public_path__ + "static/media/reverse-transaction.4a58af93.svg";